import {FC} from "react";
import {UserPatrolTabContent} from "./content";
import {useOutletContext} from "react-router-dom";
import {UserPageOutletContext} from "../index";

export const UserPatrolTab: FC = () => {
    const [user] = useOutletContext<UserPageOutletContext>();
    return <UserPatrolTabContent user={user}/>;
};
